/** Legacy customer lead records were removed from the public client bundle. */
export const LEGACY_LEADS = [];
